var plateform  = navigator.platform;
var plateforms = ["Linux aarch64", "iPhone", "iPad", "MacIntel", "Linux x86_64", "Win32", "Win64", "OpenBSD amd64", "FreeBSD amd64", "PlayStation 4", "PlayStation 5", "Nintendo WiiU", "WebTV OS"];
var perfomance = (plateforms.indexOf(plateform) > -1); // détection des appareil assez performant pour lancer toutes les annimations

// const banner = document.querySelector(".banner")
// const sticky = banner.offsetTop

// function position_banner() {
//   banner.classList.remove("hide")
//   banner.classList.add("fixed")
// }

// setTimeout(() => {
//   position_banner()
// }, 2000)

gsap.registerPlugin(ScrollTrigger, SplitText); //, TextPlugin, ScrollToPlugin, DrawSVGPlugin

ScrollTrigger.defaults({
  toggleActions: "play none none reverse",
  // markers: true,
  end: "bottom center",
})

if(document.querySelector('.wrap-bulle')){

  // window.addEventListener('scroll', () => {
  //   window.addEventListener('resize', () => {
  //     if (window.innerWidth >= 992) {
  //       document.querySelector('.wrap-bulle').style.top = null
  //       document.querySelector('.wrap-bulle-discord').style.top = null
  //     }
  //   })
  //   if (window.innerWidth < 992) {
  //     if(scrollY <= 100) {
  //       document.querySelector('.wrap-bulle').style.top = 115 - scrollY + "px"
  //       document.querySelector('.wrap-bulle-discord').style.top = 115 - scrollY + "px"
  //     } else {
  //       document.querySelector('.wrap-bulle').style.top = "15px"
  //       document.querySelector('.wrap-bulle-discord').style.top = "15px"
  //     }
  //   } else {
  //     document.querySelector('.wrap-bulle').style.top = null
  //     document.querySelector('.wrap-bulle-discord').style.top = null
  //   }
  // })

  document.querySelector('.wrap-bulle').addEventListener('click', () => {
    gsap.to(".wrap-bulle", {
      rotation: "+=1440",
      opacity: 0,
      ease: Linear,
      duration: 0.5,
    })

    document.querySelector('body').style.overflow = "hidden"
    gsap.fromTo('.pop-up', {display: "none", opacity: 0}, {display: "block", opacity: 1})
    gsap.fromTo('.cross', {display: "none", opacity: 0}, {display: "flex", opacity: 1})
    gsap.fromTo('.wrap-bulle', {display: "flex", opacity: 1}, {display: "none", opacity: 0})
  })

  document.querySelector('.cross').addEventListener('click', () => {
    gsap.to(".wrap-bulle", {
      clearProps: "rotation",
      duration: 0,
    })
    document.querySelector('body').style.overflow = "unset"
    gsap.fromTo('.pop-up', {display: "block", opacity: 1}, {display: "none", opacity: 0})
    gsap.fromTo('.cross', {display: "flex", opacity: 1}, {display: "none", opacity: 0})
    gsap.fromTo('.wrap-bulle', {display: "none", opacity: 0}, {display: "flex", opacity: 1})
  })

  document.querySelector('.wrap-bulle-discord').addEventListener('click', () => {
    if (window.innerWidth < 576) {
      if(document.querySelector('.wrap-bulle-discord').classList.contains('open')){
        gsap.to(".discord-iframe", {
          left: -window.innerWidth
        })
        document.querySelector('.wrap-bulle-discord').classList.remove('open')
        document.querySelector('.discord-iframe').classList.remove('open')
      } else {
        gsap.to(".discord-iframe", {
          left: 0,
          right: "unset"
        })
        document.querySelector('.wrap-bulle-discord').classList.add('open')
        document.querySelector('.discord-iframe').classList.add('open')
      }
    } else {
      if(document.querySelector('.wrap-bulle-discord').classList.contains('open')){
        gsap.to(".discord-iframe", {
          right: -350
        })
        document.querySelector('.wrap-bulle-discord').classList.remove('open')
        document.querySelector('.discord-iframe').classList.remove('open')
      } else {
        gsap.to(".discord-iframe", {
          right: 0,
          left: "unset"
        })
        document.querySelector('.wrap-bulle-discord').classList.add('open')
        document.querySelector('.discord-iframe').classList.add('open')
      }
    }
  })

  document.querySelector('.close-discord').addEventListener('click', () => {
    if (window.innerWidth < 576) {
      if(document.querySelector('.wrap-bulle-discord').classList.contains('open')){
        gsap.to(".discord-iframe", {
          left: "-100vw"
        })
        document.querySelector('.wrap-bulle-discord').classList.remove('open')
        document.querySelector('.discord-iframe').classList.remove('open')
      }
    } else {
      if(document.querySelector('.wrap-bulle-discord').classList.contains('open')){
        gsap.to(".discord-iframe", {
          right: -350
        })
        document.querySelector('.wrap-bulle-discord').classList.remove('open')
        document.querySelector('.discord-iframe').classList.remove('open')
      }
    }
  })

  window.addEventListener('resize', () => {
    if (window.innerWidth < 576) {
      if(document.querySelector('.wrap-bulle-discord').classList.contains('open')){
        gsap.to(".discord-iframe", {
          left: 0,
          right: "unset",
          duration: 0
        })
      } else {
        gsap.to(".discord-iframe", {
          left: "-100vw",
          right: "unset",
          duration: 0
        })
      }
    } else {
      if(document.querySelector('.wrap-bulle-discord').classList.contains('open')){
        gsap.to(".discord-iframe", {
          left: "unset",
          right: 0,
          duration: 0
        })
      } else {
        gsap.to(".discord-iframe", {
          right: -350,
          left: "unset",
          duration: 0
        })
      }
    }
  })

  if(window.innerWidth < 768){
    ScrollTrigger.defaults({
      start: "top 90%",
    });
  } else {
    ScrollTrigger.defaults({
      start: "top 75%",
    });
  }

  if ( objects.is_front_page ) {

    if (perfomance === true){

      setInterval(() => {
        gsap.to(".logo-discord", {
          rotation: 360,
          ease: CustomEase.create("custom", "M0,0,C0,0,-0.004,0.228,0.036,0.373,0.066,0.484,0.081,0.559,0.122,0.666,0.153,0.749,0.158,0.785,0.198,0.864,0.214,0.896,0.244,0.96,0.266,0.99,0.285,1.016,0.302,1.051,0.326,1.072,0.359,1.101,0.365,1.115,0.404,1.138,0.428,1.152,0.443,1.17,0.504,1.17,0.548,1.17,0.593,1.147,0.62,1.12,0.672,1.066,0.672,1.001,0.704,0.944,0.726,0.904,0.805,0.872,0.89,0.924,0.936,0.952,1,1,1,1"),
          duration: 0.5
        });
        gsap.to(".logo-discord", {
          rotation: 0,
          delay: 1,
          duration: 0
        });
      }, 2000);

      var titre = new SplitText("#section-2 .container .accroche h2", { type: "words,chars" }),
      charsTitre = titre.chars; //an array of all the divs that wrap each character

      gsap.fromTo(charsTitre, {
        scale: 0,
        ease: CustomEase.create("custom", "M0,0,C0.422,0,0.766,0.288,0.766,0.702,0.766,1,0.914,1,1,1"),
      }, {
        scrollTrigger: {
          trigger: "#section-2 .container .accroche h2",
        },
        scale: 1,
        stagger: 0.01,
        duration: 0.5,
      });

      var txt = new SplitText("#section-2 .container .text-img .text p", { type: "words,chars" }),
      charsTxt = txt.chars; //an array of all the divs that wrap each character

      gsap.fromTo(charsTxt, {
        opacity: 0,
        ease: CustomEase.create("custom", "M0,0,C0.422,0,0.766,0.288,0.766,0.702,0.766,1,0.914,1,1,1"),
      }, {
        scrollTrigger: {
          trigger: "#section-2 .container .text-img .text p",
        },
        opacity: 1,
        stagger: 0.005,
        duration: 0.5,
      });

      var legend = new SplitText("#section-3 .bloc.haut .accroche h1", { type: "words,chars" }),
      charsLegend = legend.chars; //an array of all the divs that wrap each character

      gsap.fromTo(charsLegend, {
        scale: 0,
        ease: CustomEase.create("custom", "M0,0,C0.422,0,0.766,0.288,0.766,0.702,0.766,1,0.914,1,1,1"),
      }, {
        scrollTrigger: {
          trigger: "#section-3 .bloc.haut .accroche h1",
        },
        scale: 1,
        stagger: 0.01,
        duration: 0.5,
      });

      var text = new SplitText("#section-3 .story .text", { type: "words,chars" }),
      charsText = text.chars; //an array of all the divs that wrap each character

      gsap.fromTo(charsText, {
        opacity: 0,
        ease: CustomEase.create("custom", "M0,0,C0.422,0,0.766,0.288,0.766,0.702,0.766,1,0.914,1,1,1"),
      }, {
        scrollTrigger: {
          trigger: "#section-3 .story .text",
        },
        opacity: 1,
        stagger: 0.002,
        duration: 0.5,
      });

      var bataille = new SplitText("#section-3 .story h2.txt", { type: "words,chars" }),
      charsBataille = bataille.chars; //an array of all the divs that wrap each character

      gsap.fromTo(charsBataille, {
        scale: 0,
        ease: CustomEase.create("custom", "M0,0,C0.422,0,0.766,0.288,0.766,0.702,0.766,1,0.914,1,1,1"),
      }, {
        scrollTrigger: {
          trigger: "#section-3 .story h2.txt",
        },
        scale: 1,
        stagger: 0.01,
        duration: 0.5,
      });
    }

    gsap.fromTo("#section-3 .bloc.milieu .wrap.figurines-a .gsap-container", {
      x: -1000
    }, {
      scrollTrigger: {
        trigger: "#section-3 .bloc.milieu .wrap.figurines-a",
      },
      x: 0,
      stagger: -0.25,
      ease: "power3.out",
      duration: 1
    });

    gsap.fromTo("#section-3 .bloc.milieu .wrap.figurines-b .gsap-container", {
      x: 1000
    }, {
      scrollTrigger: {
        trigger: "#section-3 .bloc.milieu .wrap.figurines-b",
      },
      x: 0,
      stagger: 0.25,
      ease: "power3.out",
      duration: 1
    });

    gsap.fromTo("#section-3 .bloc.milieu .wrap.pyramide .wrapper .img", {
      scale: 0
    }, {
      scrollTrigger: {
        trigger: "#section-3 .bloc.milieu .wrap.pyramide .wrapper .img",
      },
      scale: 1,
      duration: 1
    });

    gsap.fromTo("#section-3 .bloc.bas.row .left img", {
      scale: 0
    }, {
      scrollTrigger: {
        trigger: "#section-3 .bloc.bas.row .left img",
      },
      scale: 1,
      duration: .75
    });

    gsap.fromTo("#section-3 .bloc.bas.row .right img", {
      scale: 0
    }, {
      scrollTrigger: {
        trigger: "#section-3 .bloc.bas.row .right img",
      },
      scale: 1,
      duration: 0.75
    });

    gsap.fromTo("#section-4 .container .wrap .img", {
      y: 300
    }, {
      scrollTrigger: {
        trigger: "#section-4 .container .wrap .img",
      },
      y: 0,
      duration: 0.75
    });

    if (perfomance === true){

      var lets = new SplitText("#section-4 .container .wrap h2", { type: "words,chars" }),
      charsLets = lets.chars; //an array of all the divs that wrap each character

      gsap.fromTo(charsLets, {
        y: 300
      }, {
        scrollTrigger: {
          trigger: "#section-4 .container .wrap h2"
        },
        y: 0,
        stagger: 0.15,
        ease: CustomEase.create("custom", "M0,0,C0.422,0,0.766,0.288,0.766,0.702,0.766,1,0.914,1,1,1"),
        duration: 0.5,
      });

      var fight = new SplitText("#section-4 .container .wrap .txt .txt-effect", { type: "words,chars" }),
      charsFight = fight.chars; //an array of all the divs that wrap each character

      gsap.fromTo(charsFight, {
        x: 1000
      }, {
        scrollTrigger: {
          trigger: "#section-4 .container .wrap .txt",
        },
        x: 0,
        stagger: 0.15,
        ease: CustomEase.create("custom", "M0,0,C0.422,0,0.766,0.288,0.766,0.702,0.766,1,0.914,1,1,1"),
        duration: 0.5
      });
    }

    gsap.fromTo("#section-4 .container .wrap .txt .annotation", {
      x: 1000
    }, {
      scrollTrigger: {
        trigger: "#section-4 .container .wrap .txt",
      },
      x: 10,
      ease: CustomEase.create("custom", "M0,0,C0.422,0,0.766,0.288,0.766,0.702,0.766,1,0.914,1,1,1"),
      duration: 1,
      delay: 0.25
    });

    if (perfomance === true){

      var deck = new SplitText("#section-4 .container .text", { type: "words,chars" }),
      charsDeck = deck.chars; //an array of all the divs that wrap each character

      gsap.fromTo(charsDeck, {
        scale: 0,
        ease: CustomEase.create("custom", "M0,0,C0.422,0,0.766,0.288,0.766,0.702,0.766,1,0.914,1,1,1"),
      }, {
        scrollTrigger: {
          trigger: "#section-4 .container .text",
        },
        scale: 1,
        stagger: 0.01,
        duration: 0.5,
      });
    }

    gsap.to("#section-4 .container .deck .types .legendaire .img-card-bg", {
      scrollTrigger: {
        trigger: "#section-4 .container .deck .types .legendaire",
      },
      ease: "power3.out",
      delay: 0.75,
      clearProps:"background"
    });

    gsap.fromTo("#section-4 .container .deck .types .legendaire img", {
      y: 500
    }, {
      scrollTrigger: {
        trigger: "#section-4 .container .deck .types .legendaire",
      },
      y: 0,
      ease: "power3.out",
      duration: 1,
    });

    gsap.to("#section-4 .container .deck .types .attaque .img-card-bg", {
      scrollTrigger: {
        trigger: "#section-4 .container .deck .types .attaque",
      },
      ease: "power3.out",
      delay: 0.75,
    });

    gsap.fromTo("#section-4 .container .deck .types .attaque img", {
      y: 500
    }, {
      scrollTrigger: {
        trigger: "#section-4 .container .deck .types .attaque",
      },
      y: 0,
      ease: "power3.out",
      duration: 1,
    });

    gsap.to("#section-4 .container .deck .types .deplacement .img-card-bg", {
      scrollTrigger: {
        trigger: "#section-4 .container .deck .types .deplacement",
      },
      ease: "power3.out",
      delay: 0.75,
    });

    gsap.fromTo("#section-4 .container .deck .types .deplacement img", {
      y: 500
    }, {
      scrollTrigger: {
        trigger: "#section-4 .container .deck .types .deplacement",
      },
      y: 0,
      ease: "power3.out",
      duration: 1,
    });

    gsap.to("#section-4 .container .deck .types .magie .img-card-bg", {
      scrollTrigger: {
        trigger: "#section-4 .container .deck .types .magie",
      },
      ease: "power3.out",
      delay: 0.75,
    });

    gsap.fromTo("#section-4 .container .deck .types .magie img", {
      y: 500
    }, {
      scrollTrigger: {
        trigger: "#section-4 .container .deck .types .magie",
      },
      y: 0,
      ease: "power3.out",
      duration: 1,
    });

    if (perfomance === true){

      var combat = new SplitText("#section-5 .haut h2.accroche", { type: "words,chars" }),
      charsCombat = combat.chars; //an array of all the divs that wrap each character

      gsap.fromTo(charsCombat, {
        scale: 0,
        ease: CustomEase.create("custom", "M0,0,C0.422,0,0.766,0.288,0.766,0.702,0.766,1,0.914,1,1,1"),
      }, {
        scrollTrigger: {
          trigger: "#section-5 .haut h2.accroche",
        },
        scale: 1,
        stagger: 0.01,
        duration: 0.5,
      });
    }

    gsap.fromTo("#section-6", {
      opacity: 0
    }, {
      scrollTrigger: {
        trigger: "#section-6",
      },
      opacity: 1,
      ease: "power3.out",
      duration: 2,
    });

    //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// desktop only
    if(window.innerWidth > 768){

      gsap.fromTo("#section-2 .container .text-img .img", {
        x: 1000
      }, {
        scrollTrigger: {
          trigger: "#section-2 .container .text-img .img",
        },
        x: 0, 
        ease: "power3.out",
        duration: 1
      });

      gsap.fromTo("#section-5 .haut .container .text", {
        x: 1000
      }, {
        scrollTrigger: {
          trigger: "#section-5 .haut .container .text",
        },
        x: 0, 
        ease: "power3.out",
        duration: 1
      });
    
      gsap.fromTo("#section-5 .container .milieu .text", {
        x: -1000
      }, {
        scrollTrigger: {
          trigger: "#section-5 .container .milieu .text",
        },
        x: 0, 
        ease: "power3.out",
        duration: 1
      });
    
      gsap.fromTo("#section-5 .container .bas .top .text", {
        x: 1000
      }, {
        scrollTrigger: {
          trigger: "#section-5 .container .bas .top .text",
        },
        x: 0, 
        ease: "power3.out",
        duration: 1
      });
    
      gsap.fromTo("#section-5 .container .bas .bottom .text", {
        x: -1000
      }, {
        scrollTrigger: {
          trigger: "#section-5 .container .bas .bottom .text",
        },
        x: 0, 
        ease: "power3.out",
        duration: 1
      });
    };

    //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// mobile only
    if(window.innerWidth < 768){

      gsap.fromTo("#section-2 .container .text-img .text", {
        scale: 0
      }, {
        scrollTrigger: {
          trigger: "#section-2 .container .text-img .text",
        },
        scale: 1, 
        ease: "power3.out",
        duration: 1
      });

      gsap.fromTo("#section-2 .container .text-img .img", {
        scale: 0
      }, {
        scrollTrigger: {
          trigger: "#section-2 .container .text-img .img",
        },
        scale: 1, 
        ease: "power3.out",
        duration: 1
      });

      gsap.fromTo("#section-5 .haut .container .text", {
        scale: 0
      }, {
        scrollTrigger: {
          trigger: "#section-5 .haut .container .text",
        },
        scale: 1, 
        ease: "power3.out",
        duration: 1
      });
    
      gsap.fromTo("#section-5 .container .milieu .text", {
        scale: 0
      }, {
        scrollTrigger: {
          trigger: "#section-5 .container .milieu .text",
        },
        scale: 1, 
        ease: "power3.out",
        duration: 1
      });
    
      gsap.fromTo("#section-5 .container .bas .top .text", {
        scale: 0
      }, {
        scrollTrigger: {
          trigger: "#section-5 .container .bas .top .text",
        },
        scale: 1, 
        ease: "power3.out",
        duration: 1
      });
    
      gsap.fromTo("#section-5 .container .bas .bottom .text", {
        scale: 0
      }, {
        scrollTrigger: {
          trigger: "#section-5 .container .bas .bottom .text",
        },
        scale: 1, 
        ease: "power3.out",
        duration: 1
      });
    }
    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  }
}


if(document.querySelector('.link-google')){
  document.querySelector('.link-google').addEventListener('click', () => {
    document.querySelector('body').style.overflow = "hidden"
    gsap.fromTo('.rule-pop-up', {display: "none", opacity: 0}, {display: "block", opacity: 1})
    gsap.fromTo('.rule-cross', {display: "none", opacity: 0}, {display: "flex", opacity: 1})
    document.querySelector('#navbar-toggle').checked = false
  })

  document.querySelector('.rule-cross').addEventListener('click', () => {
    document.querySelector('body').style.overflow = "unset"
    gsap.fromTo('.rule-pop-up', {display: "block", opacity: 1}, {display: "none", opacity: 0})
    gsap.fromTo('.rule-cross', {display: "flex", opacity: 1}, {display: "none", opacity: 0})
  })
}

if(document.querySelector('.footer-regles')){
  // alert(window.innerHeight)
  if (window.innerHeight <= 666) {
    document.querySelector('.menu').style.height = "0px"
    document.querySelector('.footer-regles').style.display = "none"
  } else {
    document.querySelector('.menu').style.height = "60px"
    document.querySelector('.footer-regles').style.display = "block"
  }
  window.addEventListener('resize', () => {
    if (window.innerHeight <= 666) {
      document.querySelector('.menu').style.height = "0px"
      document.querySelector('.footer-regles').style.display = "none"
    } else {
      document.querySelector('.menu').style.height = "60px"
      document.querySelector('.footer-regles').style.display = "block"
    }
  })
}